<div *ngIf="deviceState==null" class="btn btn-gray btn-circle btn-sm"><i class="fas fa-question"></i></div>
<div *ngIf="deviceState!=null">
    <div *ngIf="deviceState" class="btn btn-green btn-circle btn-sm"></div>
    <div *ngIf="!deviceState" class="btn btn-red btn-circle btn-sm"></div>
</div>
